import { render, staticRenderFns } from "./SearchClinic.vue?vue&type=template&id=3c47c60b&"
import script from "./SearchClinic.vue?vue&type=script&lang=js&"
export * from "./SearchClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports